<template>
  <search-page-layout title="교육영상 관리">
    <template v-slot:tabBar>
      <v-tabs v-model="activeTab" center-active show-arrows>
        <v-tab v-for="(category, index) in allCategoryList" :key="index">
          {{ category.categoryNm }}
        </v-tab>
        <v-tab-item v-for="(category, index) in allCategoryList" :key="index">
          <lecture-manage-table
            :categoryList="categoryList"
            :data="category.videoList"
            @refresh="refreshList"
          />
        </v-tab-item>
      </v-tabs>
    </template>
  </search-page-layout>
</template>

<script>
import SearchPageLayout from "@/common/layout/SearchPageLayout";
import LectureManageTable from "@/pages/Lecture/components/manage/LectureManageTable.vue";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import _ from "lodash";

export default {
  name: "LectureManage",
  components: {SearchPageLayout, LectureManageTable,},
  data() {
    return {
      activeTab: 0,
      categoryList: [],
      allCategoryList: [],
      nowCategoryId: 0
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId"
    })
  },
  async created() {
    // 전체 카테고리 목록 조회
    await this.getLectureCategoryList();
    // 카테고리[전체]에 대한 전체 비디오목록 셋팅
    const data = await this.getLectureVideoList(0);
    this.$set(this.allCategoryList[0], "videoList", data);
  },
  watch: {
    // 카테고리 탭에 따라 비디오 목록 셋팅
    async activeTab(newValue, oldValue) {
      if (newValue !== oldValue) {
        const findIndexItem = this.allCategoryList.find(item => item.index === newValue);
        if (findIndexItem) {
          const data = await this.getLectureVideoList(findIndexItem.categoryId);
          this.$set(this.allCategoryList[newValue], "videoList", data);
        }
      }
    }
  },
  methods: {
    // 카테고리 목록 조회
    async getLectureCategoryList() {
      try {
        const { data } = await axiosInstance.get("/private/training/category", {
          params: {
            memberId: this.memberId,
            useYn: ""
          }
        });
        if (data.length < 1) {
          this.categoryList = [];
          this.allCategoryList = [{categoryNm: "전체", categoryId: 0}];
        } else {
          this.categoryList = data;
          this.allCategoryList = [{categoryNm: "전체", categoryId: 0}, ...this.categoryList];
          let idx = 0;
          for (const item of this.allCategoryList) {item["index"] = idx++}
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    // 카테고리별 영상 목록 조회
    async getLectureVideoList(categoryId) {
      this.nowCategoryId = categoryId;
      try {
        const { data } = await axiosInstance.get("/admin/training/training-list", {
          params: {
            categoryId: categoryId
          }
        });
        if (!_.isEmpty(data)) {
          return data;
        } else {
          return [];
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    async refreshList() {
      const data = await this.getLectureVideoList(this.nowCategoryId);
      this.$set(this.allCategoryList[this.nowCategoryId], "videoList", data);
    }
  }
}
</script>
